var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHavayarTinylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 25.47,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(13372 -7955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices",
    transform: "translate(-13372 7954.764)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1647",
    "data-name": "Rectangle 1647",
    width: 40,
    height: 39,
    transform: "translate(0 0.236)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_logo",
    "data-name": "sign logo",
    transform: "translate(-13365 7965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.6,7.183l-2.89,4.787a.814.814,0,0,1-.7.4h-.741l2.937-4.854a.315.315,0,0,0-.256-.482H26.365a.285.285,0,0,1-.232-.436l.277-.458,3.561-5.9A.158.158,0,0,0,29.843,0H26.837a.3.3,0,0,0-.256.147L18.988,12.723a.157.157,0,0,0,.128.241h3.007a.3.3,0,0,0,.256-.147l2.893-4.792a.814.814,0,0,1,.7-.4h.724L23.759,12.48a.315.315,0,0,0,.256.482h3.6a.285.285,0,0,1,.232.436L24,19.758a.157.157,0,0,0,.128.241h3.007a.3.3,0,0,0,.256-.147l4.031-6.678,3.56-5.9a.157.157,0,0,0-.128-.241H31.854a.3.3,0,0,0-.256.147",
    transform: "translate(-14.583 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M9.126,20.7a11.573,11.573,0,0,1-3.376-.978l-.211-.1a8.37,8.37,0,0,1-3.268-2.643,6.48,6.48,0,0,1-.145-7.241l-.009.006a14.415,14.415,0,0,1,8.932-6.569h0l.119-.2a17.974,17.974,0,0,0-6.59,3.3l-.122.1L4.305,6.5h0l-.152.13A13.592,13.592,0,0,0,1.4,9.821c-1.8,2.965-1.875,6.143-.162,8.547a7.671,7.671,0,0,0,2.079,1.961q.308.2.635.379a10.848,10.848,0,0,0,4.161,1.369.277.277,0,0,0,.264-.135Z",
    transform: "translate(0 -2.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M70.054,4.086a7.678,7.678,0,0,0-2.079-1.961l-.11-.07c-.19-.12-.387-.234-.587-.342A11.329,11.329,0,0,0,62.648.353a.277.277,0,0,0-.255.136L61.669,1.7a12.016,12.016,0,0,1,3.883,1.034l.2.094a8.376,8.376,0,0,1,3.268,2.645,6.462,6.462,0,0,1,.212,7.124c-.023.043-.063.114-.117.207l-.029.051-.017.026a14.925,14.925,0,0,1-8.808,6.362c-.192.053-.37.1-.538.145l-.134.224a18.056,18.056,0,0,0,7-3.336q.124-.1.245-.2h0c.1-.085.205-.171.306-.258a13.523,13.523,0,0,0,2.753-3.195c1.8-2.963,1.875-6.14.161-8.543",
    transform: "translate(-45.822 -0.268)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHavayarTinylogo);
export default __webpack_public_path__ + "static/media/havayar-tinylogo.62a1c679713534be3f8f3193620032db.svg";
export { ForwardRef as ReactComponent };